"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function nlc2(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.6132 10.2892L12.1575 7.42725C12.4605 6.76725 12.612 6.39225 12.612 6.306C12.612 5.99625 12.408 5.76975 12.0007 5.625H16.4618C15.912 5.8725 15.423 6.49125 14.9955 7.482L13.6132 10.2892ZM11.4262 14.7352L10.7475 16.1152H14.7502C16.563 16.1152 17.775 15.7755 18.3862 15.0953L16.2472 18.375H5.3085C6.48975 18.1477 7.6815 16.725 8.883 14.1045C9.288 13.299 9.65925 12.555 9.99825 11.874L11.4262 14.7352ZM3.75 15.1875C4.63575 14.6617 7.875 9.0585 7.875 7.482C7.875 7.11075 7.65075 6.75975 7.203 6.42975H10.686L13.7108 12.3713L16.6448 6.42975H20.25C18.7222 6.83175 15.6975 14.0392 15.6975 14.8778C15.6975 15.0428 15.7275 15.1462 15.789 15.1875H12.6112L9.89175 9.741L7.203 15.1875H3.75Z", fill: color }));
}
exports["default"] = nlc2;
//# sourceMappingURL=nlc2.js.map